 
import parserPostCSS from 'grapesjs-parser-postcss'
import rteExtension from 'grapesjs-rte-extensions'
import webpage from 'grapesjs-preset-webpage'
import blockBasics from 'grapesjs-blocks-basic'

// Custom Plugins
import visibilityTraitPlugin from './custom/visibilityTraitPlugin'
import videoEmbedPlugin from '../components/video'
import rteToolbarPlugin from './custom/rteToolbarPlugin'
import imageDefaultsPlugin from './custom/imageDefaultsPlugin'

export default {
  plugins: [
    blockBasics,
    webpage,
    parserPostCSS,
    rteExtension,

    // Custom Plugins
    visibilityTraitPlugin,
    videoEmbedPlugin,
    rteToolbarPlugin,
    imageDefaultsPlugin,
  ]
}
